import { render, staticRenderFns } from "./SidebarSubMenu.vue?vue&type=template&id=33a33029&scoped=true&"
import script from "./SidebarSubMenu.vue?vue&type=script&lang=js&"
export * from "./SidebarSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSubMenu.vue?vue&type=style&index=0&id=33a33029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a33029",
  null
  
)

export default component.exports